import client from './client';

export const getConversations = async () => {
  const res = await client.get('/api/whatsapp/conversations');
  return res.data;
};

export const getMessages = async (sessionId) => {
  const res = await client.get(`/api/whatsapp/conversations/${sessionId}/messages`);
  return res.data;
};

export const markAsRead = async (sessionId) => {
  const res = await client.post(`/api/whatsapp/conversations/${sessionId}/read`);
  return res.data;
};

export const blockNumber = async (sessionId) => {
  const res = await client.post(`/api/whatsapp/conversations/${sessionId}/block`);
  return res.data;
};

export const unblockNumber = async (sessionId) => {
  const res = await client.post(`/api/whatsapp/conversations/${sessionId}/unblock`);
  return res.data;
};

export const sendMessage = async (to, text) => {
  const res = await client.post('/api/whatsapp/chat/send', { to, text });
  return res.data;
};

export const sendMedia = async (to, file, caption = '') => {
  const form = new FormData();
  form.append('to', to);
  form.append('file', file);
  if (caption) form.append('caption', caption);
  const res = await client.post('/api/whatsapp/chat/send', form);
  return res.data;
};

export const mediaUrl = (id) => {
  const base = (client.defaults.baseURL || '').replace(/\/$/, '');
  return `${base}/api/whatsapp/media/${encodeURIComponent(id)}`;
};

export const loadMedia = async (id) => {
  const res = await client.get(`/api/whatsapp/media/${encodeURIComponent(id)}`, { responseType: 'blob' });
  return window.URL.createObjectURL(res.data);
};

export const downloadMedia = async (id, fileName = 'media') => {
  const res = await client.get(`/api/whatsapp/media/${encodeURIComponent(id)}`, {
    params: { download: '1' },
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
};

export const exportChats = async (sessionId) => {
  const params = sessionId ? { sessionId } : {};
  const res = await client.get('/api/whatsapp/conversations/export', { params, responseType: 'blob' });
  return res.data;
};
